import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import JanelaModal from '../../JanelaModal';
import {
  darSaidaDeSemen, MOTIVOS_DE_SAIDA_DE_SEMEN, rotuloDaPartida, emDoses,
} from '../../../data/semen';
import { enderecoDoBotijao } from '../../../data/estoque';
import { MARK } from '../../../constants';

const input = 'w-full px-2 py-1.5 border border-slate-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

const Campo = ({ label, children, dica }) => (
  <div>
    <label className="block text-xs font-medium text-slate-700 mb-1">{label}</label>
    {children}
    {dica && <p className="text-xs text-slate-400 mt-0.5">{dica}</p>}
  </div>
);

/**
 * Saída de doses do botijão.
 *
 * Substitui os dois `window.prompt` que faziam a "baixa". Não é frescura de
 * tela: o prompt guardava um TOTAL que se sobrescrevia, sem data e sem motivo
 * separado — quem deu baixa de 3 e depois de 2 não deixava duas saídas, deixava
 * o número 5 e nenhuma pista de quando. Aqui cada saída é um lançamento com a
 * sua data, e o extrato da partida mostra os dois.
 *
 * O QUE SAI PELA FIV NÃO SE LANÇA AQUI. A palheta descongelada na sessão já
 * baixa sozinha; lançá-la de novo faria a mesma dose sair duas vezes do saldo.
 */
const SaidaDeSemen = ({ partida, onPronto, onFechar }) => {
  const [f, setF] = useState({
    doses: '',
    data: new Date().toISOString().slice(0, 10),
    motivo: 'uso_externo',
    destino: '',
    observacoes: '',
  });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const saldo    = Number(partida?.saldo_doses) || 0;
  const pedidas  = Number(f.doses) || 0;
  const restante = saldo - pedidas;
  const pode     = pedidas > 0 && f.motivo && f.data && !salvando;

  const gravar = async () => {
    setSalvando(true); setErro('');
    try {
      await darSaidaDeSemen(partida, f);
      onPronto?.();
      onFechar?.();
    } catch (e) {
      console.error('saída de sêmen:', e);
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <JanelaModal chave="saida-semen" Icone={LogOut} titulo="Saída de sêmen" onFechar={onFechar} largura="sm:max-w-lg">
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          <div className="bg-slate-50 border border-slate-200 rounded p-3">
            <p className="text-sm font-medium text-slate-900">{rotuloDaPartida(partida)}</p>
            <p className="text-xs text-slate-600 mt-0.5">
              {emDoses(saldo)} dose{saldo === 1 ? '' : 's'} no estoque
              {enderecoDoBotijao(partida) ? ` · ${enderecoDoBotijao(partida)}` : ''}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Campo label="Doses que saíram *" dica="Meia palheta pode: 0,5">
              <input className={input} type="number" min="0.5" step="0.5" value={f.doses}
                onChange={(e) => set('doses', e.target.value)} />
            </Campo>
            <Campo label="Data da saída *" dica="O dia em que saiu, não o de hoje">
              <input className={input} type="date" value={f.data}
                onChange={(e) => set('data', e.target.value)} />
            </Campo>
          </div>

          <Campo label="Motivo *">
            <select className={input} value={f.motivo} onChange={(e) => set('motivo', e.target.value)}>
              {MOTIVOS_DE_SAIDA_DE_SEMEN.map(m => (
                <option key={m.id} value={m.id}>{m.label}</option>
              ))}
            </select>
          </Campo>

          <Campo label="Para quem foi" dica="Cliente, fazenda ou laboratório que recebeu">
            <input className={input} value={f.destino}
              onChange={(e) => set('destino', e.target.value)} />
          </Campo>

          <Campo label="Observação">
            <input className={input} value={f.observacoes}
              onChange={(e) => set('observacoes', e.target.value)} />
          </Campo>

          {/* O saldo não trava a gravação — quem está com o botijão aberto sabe
              o que tirou melhor que o sistema. O aviso existe para revelar
              estoque desatualizado, não para impedir o lançamento. */}
          {pedidas > 0 && (
            <p className="text-xs text-slate-600">
              {restante < 0
                ? `${MARK.WARN} O estoque registra ${emDoses(saldo)}. A saída é salva assim mesmo — confira as entradas desta partida.`
                : `Ficam ${emDoses(restante)} no estoque.`}
            </p>
          )}

          {erro && (
            <div className="bg-slate-50 border border-slate-300 text-slate-700 text-sm rounded px-3 py-2">
              {erro}
            </div>
          )}
        </div>

        <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onFechar}
            className="px-4 py-2 border border-slate-300 rounded text-sm text-slate-700 hover:bg-slate-50">
            Cancelar
          </button>
          <button onClick={gravar} disabled={!pode}
            className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-40">
            {salvando ? 'Gravando…' : 'Lançar saída'}
          </button>
        </div>
    </JanelaModal>
  );
};

export default SaidaDeSemen;
